import { ButtonPrimeReact } from "@finanedi.es/storybook"
import {
  useCuentaContableEmpresaRetencionCompra,
  useCuentaContableEmpresaRetencionVenta,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaRetencionCompra,
  useCuentaContableCuentaRetencionVenta,
} from "api/CuentaContable_Cuenta.hook"
import {
  postImpuestoEmpresa,
  putImpuestoEmpresa,
} from "api/ImpuestoEmpresa.service"
import { TIPO_IMPUESTO_EMPRESA_ENUM } from "api/Types/TipoImpuestoEmpresaEnum"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import FormikInputNumber from "common/components/FormikFields/FormikInputNumber"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import Modal from "common/components/Modal/Modal"
import Spinner from "common/components/Spinner"
import notification from "common/utils/notification"
import { withFormik } from "formik"
import { Dropdown, DropdownChangeParams } from "primereact/dropdown"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"
import { obtenerOpcionesPorGrupoImpuesto } from "../constants"

const TaxesModal = ({
  taxes = [],
  setEdit,
  show = false,
  setShow,
  editing = false,
  isLoading,
  values,
  setFieldValue,
  handleSubmit,
  setErrors,
}: $TSMigrationFixMe) => {
  const { cuentasContablesEmpresas: listaDeCuentasRetencionesVentasBase } =
    useCuentaContableCuentaRetencionVenta()
  const {
    cuentasContablesEmpresas: listaDeCuentasRetencionesVentas,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasRetencionesVentas,
  } = useCuentaContableEmpresaRetencionVenta()

  const { cuentasContablesEmpresas: listaDeCuentasRetencionComprasBase } =
    useCuentaContableCuentaRetencionCompra()
  const {
    cuentasContablesEmpresas: listaDeCuentasRetencionCompras,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasRetencionesCompras,
  } = useCuentaContableEmpresaRetencionCompra()

  const { t } = useTranslation()
  // @ts-expect-error TS(7006): Parameter 'taxe' implicitly has an 'any' type.
  const taxesGroupItems = taxes?.map((taxe) => ({
    label: taxe.descripcion,
    value: taxe.id,
  }))

  useEffect(() => {
    setErrors({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  const handleSelectCtaContable = (e: DropdownChangeParams) => {
    setFieldValue("cuentaContableEmpresaId", e.value)
  }

  const handleClose = () => {
    setShow(false)
    setEdit(false)
  }

  const opcionesPorGrupoImpuesto = {
    [TIPO_IMPUESTO_EMPRESA_ENUM.COMPRA]: {
      cuentas: listaDeCuentasRetencionCompras,
      cuentasBase: listaDeCuentasRetencionComprasBase,
      refreshFetchData: refresListaDeCuentasRetencionesCompras,
    },
    [TIPO_IMPUESTO_EMPRESA_ENUM.VENTA]: {
      cuentas: listaDeCuentasRetencionesVentas,
      cuentasBase: listaDeCuentasRetencionesVentasBase,
      refreshFetchData: refresListaDeCuentasRetencionesVentas,
    },
  }

  const { cuentas } = obtenerOpcionesPorGrupoImpuesto(
    opcionesPorGrupoImpuesto,
    values
  )

  return (
    <Modal
      header={
        editing
          ? `${t("impuestos.modal.editTax")}`
          : `${t("impuestos.modal.newTax")}`
      }
      visible={show}
      maskClassName='!tw-z-40'
      onHide={handleClose}
      size='big'
      draggable
    >
      <form onSubmit={handleSubmit}>
        <div className='tw-relative'>
          <div className='tw-flex tw-flex-col tw-w-full tw-pb-6'>
            <label>{t("impuestos.modal.labelName")}</label>
            <FormikInputText
              name='nombre'
              placeholder={t("impuestos.modal.placeholderName")}
              className='tw-w-full'
            />
          </div>

          <div className='tw-flex tw-flex-col tw-w-full tw-pb-6'>
            <label>{t("impuestos.modal.labelImport")}</label>
            <FormikInputNumber
              disabled={values.default}
              name='valor'
            />
          </div>

          <div className='tw-flex tw-flex-row tw-w-full tw-pb-6 tw-gap-4'>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <label>{t("impuestos.modal.labelGroup")}</label>
              <Dropdown
                value={values.grupoImpuestoId}
                options={taxesGroupItems}
                onChange={(e) => setFieldValue("grupoImpuestoId", e.value)}
                disabled={values.default}
                placeholder={`${t("impuestos.modal.placeholderGroup")}`}
                className={`tw-w-full ${
                  values.default
                    ? "tw-bg-neutral-10 [&>:nth-child(n)]:tw-bg-neutral-10 [&>:nth-child(n)]:!tw-cursor-not-allowed !tw-cursor-not-allowed"
                    : ""
                }`}
              />
            </div>
          </div>

          <div className='tw-flex tw-flex-col tw-w-full tw-pb-8'>
            <label>{t("impuestos.modal.labelTaxAccount")}</label>
            <DropdownCuentasContablesConModal
              cuentasContablesOptions={cuentas || []}
              dropdownValue={values?.cuentaContableEmpresaId}
              onChange={handleSelectCtaContable}
            />
          </div>
          {isLoading && (
            <div className='tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-rounded tw-flex tw-justify-center tw-items-center tw-bg-white/10 tw-backdrop-blur-xs'>
              <Spinner className='!tw-m-0' />
            </div>
          )}
        </div>

        <div className='tw-flex tw-flex-row tw-justify-end tw-gap-6'>
          <ButtonPrimeReact
            label={`${t("impuestos.modal.cancelButton")}`}
            className='tw-h-12 !tw-bg-inherit !tw-text-primary !tw-border-none'
            onClick={handleClose}
          />
          <ButtonPrimeReact
            type='submit'
            label={`${
              editing
                ? `${t("impuestos.modal.saveButton")}`
                : `${t("impuestos.modal.createButton")}`
            } ${t("impuestos.modal.restButtonText")}`}
            className='tw-h-12 !tw-bg-primary !tw-border-none tw-text-simple-10'
          />
        </div>
      </form>
    </Modal>
  )
}

export const validateForm = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    nombre: Yup.string().required(t("errors.fieldEmpty")),
    valor: Yup.number()
      .required(t("errors.valueEmpty"))
      .moreThan(-1, t("errors.positiveValue"))
      .typeError(t("errors.fieldEmpty")),
  })

const Form = withFormik({
  // @ts-expect-error TS(2339): Property 'edit' does not exist on type '{}'.
  mapPropsToValues: ({ edit, editing }) => {
    return {
      nombre: edit?.nombre || "",
      valor: typeof edit?.valor === "number" ? Math.abs(edit?.valor) : null,
      tipoImpuestoEmpresa: edit?.tipo ?? TIPO_IMPUESTO_EMPRESA_ENUM.COMPRA,
      grupoImpuestoId: edit?.grupoId || "",
      cuentaContableEmpresaId: edit?.cuentaContableId || "",
      id: edit?.id || "",
      default: edit?.esPorDefecto,
      isEdit: editing,
    }
  },
  validationSchema: ({ t }: $TSMigrationFixMe) => validateForm(t),
  enableReinitialize: true,
  handleSubmit: async (values, { props, resetForm, setErrors }) => {
    try {
      // @ts-expect-error TS(2339): Property 'editing' does not exist on type 'object'...
      if (!props?.editing) {
        // @ts-expect-error TS(2345): Argument of type '{ nombre: $TSFixMe; valor: number | n...
        await postImpuestoEmpresa(values).then(() => {
          // @ts-expect-error TS(2339): Property 'setShow' does not exist on type 'object'...
          props.setShow(false)
          notification.success({
            // @ts-expect-error TS(2339): Property 't' does not exist on type 'object'.
            body: `${props.t("errors.correctCreateTax")}`,
          })
          // @ts-expect-error TS(2339): Property 'refetchTableData' does not exist on type...
          props.refetchTableData()
          resetForm()
          setErrors({})
        })
      } else {
        // @ts-expect-error TS(2345): Argument of type 'number | null' is not assignable...
        values.valor = Math.abs(values.valor)
        // @ts-expect-error TS(2345): Argument of type '{ nombre: $TSFixMe; valor: number | n...
        putImpuestoEmpresa(values).then(() => {
          notification.success()
          resetForm()
          setErrors({})
          // @ts-expect-error TS(2339): Property 'confirmEdit' does not exist on type 'obj...
          props.confirmEdit()
        })
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  },
})(TaxesModal)

export default Form
